// extracted by mini-css-extract-plugin
export default {"stickyHeader":"ou12Xe26","_isSticked":"YQHuD2FF","_withShadow":"AjyTeeG4","_toHide":"EwPPQXNN","_toShow":"g0U_lZVB"};